export type CookieConsentChoice = "accepted" | "declined";

const STORAGE_KEY = "crs_cookie_consent";
const SESSION_DISMISS_KEY = "crs_cookie_consent_session_dismissed";

export function getStoredCookieConsent(): CookieConsentChoice | null {
  if (typeof window === "undefined") return null;
  const value = localStorage.getItem(STORAGE_KEY);
  if (value === "accepted" || value === "declined") return value;
  return null;
}

export function setStoredCookieConsent(choice: CookieConsentChoice) {
  localStorage.setItem(STORAGE_KEY, choice);
  sessionStorage.removeItem(SESSION_DISMISS_KEY);
}

export function isSessionConsentDismissed(): boolean {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem(SESSION_DISMISS_KEY) === "true";
}

export function markSessionConsentDismissed() {
  sessionStorage.setItem(SESSION_DISMISS_KEY, "true");
}

export function hasAnalyticsConsent(): boolean {
  return getStoredCookieConsent() === "accepted";
}

export function shouldShowCookieBanner(): boolean {
  if (getStoredCookieConsent() !== null) return false;
  if (isSessionConsentDismissed()) return false;
  return true;
}
